import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, EMPTY } from 'rxjs';
import { environment as ENV } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators'
// import 'url-search-params-polyfill';


@Injectable()
export class BaseApi {
  private baseUrl = ENV.apiBaseUrl;
  private nodeUrl = ENV.nodeUrl;
  private irtcUrl = ENV.irtcUrl;
  private applicantId: string;
  private adminId: string;
  private satSureUrl: string = ENV.satSureBaseUrl;
  private webHookUrl: string = ENV.webhookUrl;
  private kccNewUat: string = ENV.kccNewUat;
  private kccNew_BRE_Checklist: string = ENV.kccNew_BRE_Checklist;
  private endPoints = [
    'adhaarauth',
    'dlauthNew',
    'nrega',
    'panauth',
    'panocr',
    'passportocr',
    'voterauth',
    'voterOcr',
    'ebillauth',
    'lpgId',
    'lpgAuth',
    'tbillauth',
    'epfUan',
    'epfAuth',
    'esic',
    'formauth',
    'formocr',
    'itrAuth',
    'itrOcr',
    'vehicle-rc',
    'fda',
    'fssai',
    'iec',
    'shops',
    'udhyog',
    'icai',
    'icsi',
    'icwaif',
    'icwaim',
    'gst/auth',
    'gst/identity',
    'st',
    'vat',
  ];

  constructor(private name: HttpClient, private snackbar: MatSnackBar) {
    this.applicantId = this.getApplicantID() || sessionStorage.getItem('wl-applicant-id');
    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  getNodeURL() {
    return this.nodeUrl;
  }

  postWebhook(endPoint: string, payload: any): Observable<any> {
    const url = `${this.webHookUrl}${endPoint}`;
    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
  }

  postResMpWebhook(endPoint: string, payload: any): Observable<any> {
    const url = `${this.kccNewUat}/${endPoint}`;

    console.log('POST ', url);
    console.log('BODY ', payload);

    return this.name
      .post(url, payload, {
        headers: new HttpHeaders().set('isFruits', 'true'),
      })
      .pipe(map((res) => {
        console.log(res, res['headers']);
        return res;
      }));
  }

  postSatSureLogin(endPoint: string, payload: any): Observable<any> {
    const url = `${this.satSureUrl}${endPoint}`;
    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
  }

  postSatSureFarm(endPoint: string, payload: any): Observable<any> {
    const url = `${this.satSureUrl}${endPoint}`;
    return this.name
      .post(url, payload, {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', sessionStorage.getItem('satTkn'))
          .set('Access-Control-Allow-Headers', '*'),
        withCredentials: false,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  putSatSure(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.put(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        throw res;
      }
    }));
  }

  satSureGet(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.satSureUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res;
      if (res) {
        return result;
      } else {
        throw res['error'];
      }
    }));
  }

  satSurePdfGet(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');
    let headers = new HttpHeaders()
      .set('appId', sessionStorage.getItem('applicantId'))
      .set('Access-Control-Allow-Headers', '*');

    return this.name.get(url, { headers: headers }).pipe(map((res) => {
      const result = res;
      if (res && res['data']) {
        return result;
      } else {
        throw res['message'];
      }
    }));
  }

  post(endPoint: string, payload: any, isResult = false): Observable<any> {
    const url = `${this.baseUrl}/${endPoint}`;
    let ind = this.endPoints.indexOf(endPoint);
    if (ind != -1) {
      // payload.applicantId = this.applicantId;
      payload.adminId = this.adminId;
    }

    return this.name.post(url, payload).pipe(map(
      (res) => {
        if (res['error'] || res['err']) {
          return res['error'] || res['err'];
        }

        if (res['message']) {
          // for timeout error
          return 'Server Unreachable. Please try after sometime';
        }

        if (res['ContentError']) {
          return res['ContentError'];
        }

        const json = isResult ? res : res['result'];

        if (!json) {
          const err = new Error(json.message || 'No Data Available. Server Error');
          err.name = 'JsonError';
          throw err;
        }

        let errKey;
        for (const key in json) {
          if (json.hasOwnProperty(key) && key.toLowerCase().endsWith('error')) {
            errKey = key;
          }
        }

        return errKey ? json[errKey] : json;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
        }
      }
    ));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  myPost(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.post(url, payload).pipe(map((res) => this.parseResponse(res)));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  postRes(endPoint: string, payload: any, options?: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.post(url, payload, (options = undefined)).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  postResUserSearch(endPoint: string, payload: any): Observable<any> {
    const url = `${this.kccNewUat}${endPoint}`;

    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  // GET twin of postResUserSearch — same base, so the /v1/... endpoints that
  // read rather than write can be reached without a body. params go on the
  // query string, HttpClient-encoded.
  getResUserSearch(endPoint: string, params?: any): Observable<any> {
    const url = `${this.kccNewUat}${endPoint}`;

    let httpParams = new HttpParams();

    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] != null) {
        httpParams = httpParams.set(key, String(params[key]));
      }
    }

    return this.name.get(url, { params: httpParams }).pipe(map((res) => {
      return res;
    }));
  }

  postResMp(endPoint: string, payload: any): Observable<any> {
    const url = `${ENV.nodeUrl}${endPoint}`;

    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  postFile(endPoint: string, payload: FormData): Observable<any> {
    const url = `${ENV.nodeUrl}${endPoint}`;
  
    // When sending FormData, the headers are automatically set correctly by the browser
    return this.name.post(url, payload).pipe(
      map((res) => res),
      catchError((err, caught) => this.handleError(err, caught))
    );
  }
  

  postRespMicroService(endPoint: string, payload: any): Observable<any> {
    const url = `${this.satSureUrl}/v1${endPoint}`;

    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  postRespIrtc(endPoint: string, payload: any): Observable<any> {
    const url = `${this.irtcUrl}${endPoint}`;
    return this.name
      .post(url, payload, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  postResp(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;
    return this.name
      .post(url, payload, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  postRespfalse(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;
    return this.name
      .post(url, payload, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: false,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  myGetReps(endPoint: string): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name
      .get(url, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
      })
      .pipe(map((res) => {

        return res;

      }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  postRespHeader(endPoint: string): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;
    return this.name
      .post(url, {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
        withCredentials: true,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  newPost(endPoint: string, payload: any, isResult = false): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.post(url, payload).pipe(map((res) => {
      if (res['success'] && isResult) {
        return res;
      } else if (res['success'] && !isResult) {
        return res['result'] || res['results'];
      } else {
        console.error('ERROR: ', res['message']);
        this.snackbar.open(res['message'], 'OK', { duration: 3000 });
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  // TODO: replace post with newPost once auth/ocr apis are migrated to node.

  sanpost(endPoint: string, payload: any, isResult = false): Observable<any> {
    // let headers = new HttpHeaders().set('token', this.getToken());
    const url = `${this.nodeUrl}/${endPoint}`;

    return this.name.post(url, payload).pipe(map(
      (res) => {
        if (res['error'] || res['err']) {
          return res['error'] || res['err'];
        }

        if (res['message'] == 'No Previous Address Found' && res['result'] == 0) {
          return -1;
        }

        if (res['message'] == 'Address did not match' && res['result'] == 0) {
          return 0;
        }

        if (res['message'] == 'Address matched') {
          return 1;
        }

        if (res['message'] == 'Profile Name Not Match' && res['result'] == 0) {
          return 0;
        }

        if (res['message'] == 'Profile Name Match') {
          return 1;
        }

        if (res['message']) {
          // for timeout error
          return 'Server Unreachable. Please try after sometime';
        }

        if (res['ContentError']) {
          return res['ContentError'];
        }

        const json = isResult ? res : res['result'];

        if (!json) {
          const err = new Error(json.message || 'No Data Available. Server Error');
          err.name = 'JsonError';
          throw err;
        }

        let errKey;
        for (const key in json) {
          if (json.hasOwnProperty(key) && key.toLowerCase().endsWith('error')) {
            errKey = key;
          }
        }

        return errKey ? json[errKey] : json;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
        }
      }
    ));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  getComplt(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  get(url) {
    return this.name.get(url);
  }

  newGetIrtc(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.irtcUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        throw res;
      }
    }));
  }

  newGet(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        throw res;
      }
    }));
  }

  newGetTemp(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        return result;
      }
    }));
  }

  myGet(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res['result'];
      // if (res['success']) {
      return result;
      // } else {
      //   throw res;
      // }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  getAll(endPoint: string, payload?: any): Observable<any> {
    const p = new URLSearchParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        p.set(key, p[key]);
      }
    }

    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  docGet(endPoint: string, payload?: any): Observable<any> {
    let headers = new HttpHeaders().set('X-Auth-Token', 'rgMcSjpuUqTMm9E4aJqhkflnMXICfb9c');
    // const p = new URLSearchParams();

    // for (const key in payload) {
    //   if (payload.hasOwnProperty(key)) {
    //     p.set(key, p[key]);
    //   }
    // }

    const url = `https://uat.leegality.com/api/v2.0${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, { headers: headers }).pipe(map((res) => {
      const result = res['data'];
      // if (res['success']) {
      return result;
      // } else {
      //   throw res;
      // }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  aGet(endPoint: string, payload?: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;
    // return Observable.throw('Simlulated error');
    // throw Error('Simulated Error');

    return this.name.get(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
      }
    }));
  }

  put(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.put(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  aPut(endPoint: string, payload: any): Observable<any> {
    const url = `${this.nodeUrl}${endPoint}`;

    return this.name.put(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  putIrtc(endPoint: string, payload: any): Observable<any> {
    const url = `${this.irtcUrl}${endPoint}`;

    return this.name.put(url, payload).pipe(map((res) => {
      const result = res['result'];
      if (res['success']) {
        return result;
      } else {
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  private parseResponse(json) {
    if (json.success) {
      return json.result || json.results;
    } else {
      console.error('ERROR: ', json.message);
      this.snackbar.open(json.message, 'OK', { duration: 3000 });
      throw json;
    }
  }

  // Not being used
  private handleError(err, caught) {
    const message = `Unable to process your request. Try Again later`;
    this.snackbar.open(err.statusText || message, 'OK', { duration: 3000 });
    // return of(err.statusText);
    return EMPTY;
  }

  getApplicantID() {
    return sessionStorage.getItem('wl-applicant-id');
  }

  getToken() {
    if (sessionStorage.getItem('wl-token')) {
      return sessionStorage.getItem('wl-token');
    } else {
      return null;
    }
  }

  private parseResponsePdf(json) {
    if (json.success || json.status) {
      return json.data;
    } else {
      console.error('ERROR: ', json.status);
      this.snackbar.open(json.status, 'OK', { duration: 3000 });
      throw json;
    }
  }

  userSearch(endPoint: string, payload: any, isResult = false): Observable<any> {
    const url = `${this.kccNewUat}${endPoint}`;

    // payload.getAll('file')

    return this.name.post(url, payload).pipe(map((res) => {
      if (res['success'] && isResult) {
        return res;
      } else if (res['success'] && !isResult) {
        return res['result'] || res['results'];
      } else {
        console.error('ERROR: ', res['message']);
        this.snackbar.open(res['message'], 'OK', { duration: 3000 });
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  userSearch1(endPoint: string, payload: any, isResult = false): Observable<any> {
    const url = `${this.kccNewUat}${endPoint}`;

    // payload.getAll('file')

    return this.name.post(url, payload).pipe(map((res) => {
      return res;
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  userSearchIsResultTrue(endPoint: string, payload: any, isResult = true): Observable<any> {
    const url = `${this.kccNewUat}${endPoint}`;

    // payload.getAll('file')

    return this.name.post(url, payload).pipe(map((res) => {
      if (res['success'] && isResult) {
        return res;
      } else if (res['success'] && !isResult) {
        return res['result'] || res['results'];
      } else {
        console.error('ERROR: ', res['message']);
        this.snackbar.open(res['message'], 'OK', { duration: 3000 });
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  createLoan(applicantId: string): Observable<any> {
    const url = `${this.kccNewUat}${'/v1/account/create'}`;

    // payload.getAll('file')

    return this.name.post(url, { applicantId }).pipe(map((res) => {
      if (res['success']) {
        return res;
      } else if (res['success']) {
        return res['result'] || res['results'];
      } else {
        console.error('ERROR: ', res['message']);
        this.snackbar.open(res['message'], 'OK', { duration: 3000 });
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  getDocs(applicantId: string): Observable<any> {
    const url = `${this.kccNewUat}${'/v1/users/getAllDocs'}`;

    // payload.getAll('file')

    return this.name.post(url, { appId: applicantId }).pipe(map((res) => {
      if (res['success']) {
        return res;
      } else {
        console.error('ERROR: ', res['message']);
        this.snackbar.open(res['message'], 'OK', { duration: 3000 });
        throw res;
      }
    }));
    // .catch((err, caught) => this.handleError(err, caught));
  }

  downloadPdf(url, fileName) {
    this.name.get(url, { responseType: 'arraybuffer' }).subscribe(
      (pdf) => {
        const blob = new Blob([pdf], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      (err) => {}
    );
  }
}
